import React, { useEffect, useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import { adminApi } from '../adminApi';

function AdminUsers() {
  const [users,   setUsers]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');

  const load = () => { setLoading(true); adminApi.getUsers().then(r=>setUsers(r.data)).catch(()=>{}).finally(()=>setLoading(false)); };
  useEffect(()=>{ load(); },[]);

  const handleToggle = async (id) => { await adminApi.toggleUser(id).catch(()=>{}); load(); };

  const filtered = users.filter(u =>
    u.username.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <h3>Customers ({users.length})</h3>
        <div className="admin-search">
          <FiSearch size={14} color="var(--text-muted)"/>
          <input placeholder="Search users…" value={search} onChange={e=>setSearch(e.target.value)}/>
        </div>
      </div>
      <div className="admin-table-wrap">
        {loading ? <div className="admin-loading"><div className="admin-spinner"/>Loading…</div>
        : filtered.length===0 ? <div className="admin-empty">No customers yet</div>
        : (
          <table className="admin-table">
            <thead><tr><th>#</th><th>User</th><th>Email</th><th>Orders</th><th>Joined</th><th>Status</th><th>Action</th></tr></thead>
            <tbody>
              {filtered.map((u,i)=>(
                <tr key={u.id}>
                  <td>{i+1}</td>
                  <td>
                    <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                      <div style={{width:34,height:34,borderRadius:'50%',background:'var(--accent)',color:'white',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'.8rem',fontWeight:700,flexShrink:0}}>
                        {(u.full_name||u.username)?.[0]?.toUpperCase()}
                      </div>
                      <div>
                        <div className="bold">{u.full_name}</div>
                        <div style={{fontSize:'.8rem',color:'var(--text-muted)'}}>@{u.username}</div>
                      </div>
                    </div>
                  </td>
                  <td>{u.email}</td>
                  <td>{u.orders_count}</td>
                  <td style={{whiteSpace:'nowrap'}}>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td><span className={`badge ${u.is_active?'badge-success':'badge-error'}`}>{u.is_active?'Active':'Inactive'}</span></td>
                  <td>
                    <button className={`btn-admin btn-admin-sm ${u.is_active?'btn-admin-danger':'btn-admin-ghost'}`} onClick={()=>handleToggle(u.id)}>
                      {u.is_active?'Deactivate':'Activate'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

export default AdminUsers;
